<template>
    <div class="reset-password">
        <el-card shadow="always">
            <div slot="header" class="clearfix card-title">
                <span>{{ title }}</span>
            </div>
            <el-form ref="form" :model="form" label-position="left" label-width="" :rules="rules">
                <el-form-item label="" prop="newPassword">
                    <el-input 
                        type="password" 
                        :placeholder="$t('Placeholder.EnterNewPassword')" 
                        v-model.trim="form.newPassword" 
                        clearable>
                    </el-input>
                </el-form-item>
                <el-form-item label="" prop="confirmNewPassword">
                    <el-input 
                        type="password" 
                        :placeholder="$t('Placeholder.EnterConfirmNewPassword')" 
                        v-model.trim="form.confirmNewPassword" 
                        clearable>
                    </el-input>
                </el-form-item>
                <div class="card-footer">
                    <el-button v-waves class="card-btn-login" @click="toLogin">{{ $t('Button.ToLogin') }}</el-button>
                    <el-button v-waves class="card-btn-next" type="primary" @click="nextStepClick">{{ $t('Button.Next') }}</el-button>
                </div>
            </el-form>
        </el-card>
    </div>
</template>

<script>
import waves from '@/directive/waves' // Waves directive
import { validate_password, validate_confirmPassword } from '@/utils/validate/resetPassword'
import { FormMixin } from '@/mixins'
import { apiEmailResetPassword, apiPhoneResetPassword } from '@/api/resetPassword'

export default {
    props: {
        backWay: { type: String, default: 'EMAIL'},
        title: { type: String, default: '' },
        resetKey: { type: String, default: '' },
    },
    directives: { waves },
    mixins: [FormMixin],
    name: 'ResetPasswordCard',
    data() {
        return {
            form: {
                newPassword: '',
                confirmNewPassword: '',
            },
            rules: {
                newPassword: { validator: validate_password.bind(this), trigger: 'blur' },
                confirmNewPassword: { validator: validate_confirmPassword.bind(this), trigger: 'blur' },
            },
        }
    },
    methods: {
        nextStepClick() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    let data = { password: this.form.newPassword, key: this.resetKey }
                    if(this.backWay === 'SMS'){
                        apiPhoneResetPassword(data).then(res => {
                            this.$emit('nextStepClick', '')
                        }).catch(err => {
                            this.$message.error(this.$t('Message.MsgCode' + err.code))
                        })
                    }else{
                        apiEmailResetPassword(data).then(res => {
                            if (res.data.status === 200) {
                                this.$emit('nextStepClick', '')
                            } else {
                                this.$message.error(this.$t('Message.MsgCode' + res.data.code))
                            }
                        })
                    }
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.reset-password {
    .card-footer {
        padding: 30px 0 20px 0;
        .card-btn-login {
            width: 45%;
        }
        .card-btn-next {
            width: 45%;
        }
        .card-btn-to-register {
        }
    }
    .el-form-item {
        margin-bottom: 30px;
    }
}
</style>
